/* eslint-disable max-lines -- contains huge name list */

/**
 * Sub-folder in Google Storage bucket https://github.com/RedTecLab/home-one-assets/blob/550f28c64cf54866cafda945efec86534508ea10/.circleci/config.yml#L56
 */
const BRAND_ILLUSTRATION_FOLDER = 'brand-illustrations'

/**
 * Image names as provided in https://github.com/RedTecLab/home-one-assets/tree/main/packages/brand-illustrations
 */
export type BrandIllustrationName =
  | '18-only'
  | '2-fa-security'
  | '5-years-redcare'
  | 'account-deletion-confirmation'
  | 'account-security'
  | 'agent-centric-experience-design'
  | 'ai-readiness'
  | 'allergies-and-asthma'
  | 'always-there-for-you'
  | 'animal'
  | 'apps'
  | 'ar-and-vr'
  | 'arcade'
  | 'archive'
  | 'arena'
  | 'austrian-flag'
  | 'austrian-flags'
  | 'austrian-heart-discount'
  | 'autumn'
  | 'avatar-divers'
  | 'avatar-female'
  | 'avatar-male'
  | 'baby-family'
  | 'back-to-school'
  | 'beauty'
  | 'belgium-flag'
  | 'belgium-flags'
  | 'berlin'
  | 'bestseller'
  | 'bike'
  | 'canteen'
  | 'cashback'
  | 'cat'
  | 'child-s-cold'
  | 'child-v2'
  | 'child'
  | 'choose-an-image'
  | 'cleaning-room'
  | 'code-applied'
  | 'coffee'
  | 'cold-and-fever'
  | 'cologne'
  | 'complete-the-order'
  | 'completed'
  | 'confirmed'
  | 'consent'
  | 'contact-form'
  | 'copy-sale-code'
  | 'cough-medication'
  | 'cough-person'
  | 'coupon-in-the-app'
  | 'coupon'
  | 'credit-balance-in-euro'
  | 'credit-balance-no-currency'
  | 'credit-card'
  | 'customer-support'
  | 'cyclist'
  | 'damaged-items'
  | 'data-center'
  | 'delivered'
  | 'diets-sports'
  | 'directions'
  | 'do-you-already-know'
  | 'e-prescription-in-a-folder'
  | 'e-rezept-spaceholder'
  | 'easter-bunny'
  | 'easter-eggs'
  | 'employee-care'
  | 'empty-cart'
  | 'empty-inbox'
  | 'empty-order-list'
  | 'empty-payments'
  | 'empty-wishlist'
  | 'energetic'
  | 'entrance-driver'
  | 'entrance-logistic-team'
  | 'entrance-office-team'
  | 'expedition-laboratory'
  | 'expedition-office'
  | 'expertise'
  | 'eye-health'
  | 'face-mapping'
  | 'facility-room'
  | 'feeling-beautiful-lady'
  | 'feeling-beautiful-mirror'
  | 'feeling-cared-for'
  | 'feeling-stressed'
  | 'filled-cart'
  | 'filled-inbox'
  | 'filled-mailbox'
  | 'fire-extinguisher'
  | 'first-aid-v2'
  | 'first-aid'
  | 'flag-on-the-globe'
  | 'flexible-schedule'
  | 'flight'
  | 'foot'
  | 'forgotten-password'
  | 'free-delivery'
  | 'french-flag'
  | 'french-flags'
  | 'french-heart-discount'
  | 'growth'
  | 'halloween'
  | 'hand-washing-step-1'
  | 'hand-washing-step-2'
  | 'hand-washing-step-3'
  | 'hand-washing-step-4'
  | 'hand-washing'
  | 'hashtag'
  | 'health'
  | 'homeopathy'
  | 'horse'
  | 'hotel'
  | 'insulation-package'
  | 'insurance-number'
  | 'interaction-check'
  | 'it-installation'
  | 'it-storage'
  | 'italian-flags'
  | 'italian-heart-discount'
  | 'laboratory-office'
  | 'laboratory'
  | 'list-of-products'
  | 'locker-room-w'
  | 'locker-room'
  | 'logistics-terrace'
  | 'lounge'
  | 'make-a-selection'
  | 'maternity'
  | 'measure-eco'
  | 'medical-equipment'
  | 'medical-product'
  | 'medication-plan'
  | 'message'
  | 'milan'
  | 'missing-products'
  | 'movie-camera'
  | 'muscels-bones-joints'
  | 'news'
  | 'newsletter'
  | 'nfc-and-checkmark'
  | 'nfc-and-nfc-sign'
  | 'nfc-card'
  | 'nfc-i-phone-case-removal'
  | 'nfc-samsung-case-removal'
  | 'no-entry'
  | 'notification'
  | 'now-delivery'
  | 'now-pick-up'
  | 'now'
  | 'ods-consultation'
  | 'ods'
  | 'offline-doctor'
  | 'offset-eco'
  | 'olympic-games'
  | 'ops-control-center'
  | 'optimistic'
  | 'order-being-checked'
  | 'order-cancelled'
  | 'own-brand-family'
  | 'own-brands'
  | 'package-pending'
  | 'pain'
  | 'parapharmacy'
  | 'party-balloons'
  | 'passkey'
  | 'patient-care'
  | 'pets'
  | 'pharmacist'
  | 'pharmacy'
  | 'phone-booth'
  | 'photo-box'
  | 'pick-up'
  | 'piggy-bank-with-chf'
  | 'piggy-bank-with-euro'
  | 'pilsen'
  | 'planetary-care'
  | 'post-hr'
  | 'pregnancy'
  | 'present'
  | 'product-bundle'
  | 'product-range'
  | 'pull'
  | 'push'
  | 'ratings'
  | 'red-points'
  | 'redirect'
  | 'redpoints-redeemed'
  | 'reduce-eco'
  | 'rental-car'
  | 'repeat-prescription'
  | 'retail-off-site'
  | 'retail-on-site'
  | 'return-area'
  | 'return'
  | 'running-person'
  | 'rx'
  | 'sale-code'
  | 'scan-a-product'
  | 'scan-qr-code-on-mobile'
  | 'scan-qr-code'
  | 'scan-your-med-card'
  | 'scanner-room'
  | 'server-room'
  | 'sevenum'
  | 'shower-man'
  | 'shower-room'
  | 'shower-woman'
  | 'smoking-area'
  | 'social-security'
  | 'speaking-room'
  | 'sport'
  | 'standard-delivery'
  | 'stomach-and-intestines'
  | 'stop-smoking'
  | 'sun'
  | 'sunscreen-smile'
  | 'sunscreen'
  | 'survey'
  | 'sustainable-product'
  | 'swap'
  | 'swiss-flags'
  | 'swiss-sign-discount'
  | 'technic-room'
  | 'teeth-health'
  | 'tips-and-tricks'
  | 'tired'
  | 'toilet-disabled'
  | 'toilet-female'
  | 'toilet-male'
  | 'toilets'
  | 'tongeren'
  | 'tracking'
  | 'train'
  | 'travel-pharmacy'
  | 'under-construction'
  | 'unknown-location'
  | 'update'
  | 'vegan-cosmetics'
  | 'vegan-products'
  | 'veternary-symbol'
  | 'vip-sale'
  | 'visitor-platform'
  | 'vitamins-and-deficiencies'
  | 'waiting-for-payment-in-chf'
  | 'waiting-for-payment-in-euro'
  | 'warehouse-entrance'
  | 'we-open-doors-for-anyone'
  | 'we-start-everything-with-people'
  | 'we-stay-mission-critical'
  | 'we-think-in-lifetimes'
  | 'we-thrive-in-change'
  | 'wearing-mask-step-1'
  | 'wearing-mask-step-2'
  | 'wearing-mask-step-3'
  | 'wearing-mask-step-4'
  | 'wearing-mask-step-5'
  | 'web-camera'
  | 'winter'

/*
 * Until we have Celum integration we provide scales only for images
 * we upload manually to Google Storage bucket
 */
type BrandIllustrationScale = 1 | 2

// eslint-disable-next-line perfectionist/sort-union-types -- semantic order
export type BrandIllustrationSize = 's' | 'm'

export type BrandIllustrationType = 'clear' | 'dark' | 'light'

/**
 * `clear` brand illustration have square aspect ratio, while `dark` and `light` have 9:8
 */
const variantSizes: Record<
  `${BrandIllustrationSize}-${BrandIllustrationType}`,
  {
    height: number
    width: number
  }
> = {
  'm-clear': { height: 144, width: 144 },
  'm-dark': { height: 144, width: 162 },
  'm-light': { height: 144, width: 162 },
  's-clear': { height: 96, width: 96 },
  's-dark': { height: 96, width: 108 },
  's-light': { height: 96, width: 108 },
}

/**
 * Generates brand illustration image URL & provide the fixed size for it
 *
 * @example
 * ```json
 *  {
 *    height: 144,
 *    src: https://cdn.ref-sa-tech.io/home-one-assets/brand-illustrations/empty-cart-m-dark-2x.png,
 *    width: 162
 *  }
 * ```
 */
export const brandIllustrationGetImage = ({
  cdnUrl,
  name,
  scale = 1,
  size,
  type,
}: {
  cdnUrl: string
  name: BrandIllustrationName
  scale?: BrandIllustrationScale
  size: BrandIllustrationSize
  type: BrandIllustrationType
}): {
  height: number
  src: string
  width: number
} => {
  let fileName = `${name}-${size}-${type}`

  if (scale > 1) {
    fileName += `-${scale}x`
  }

  return {
    ...variantSizes[`${size}-${type}`],
    src: `${cdnUrl}${BRAND_ILLUSTRATION_FOLDER}/${fileName}.png`,
  }
}
